import * as ss from 'superstruct';
import { Id } from '../../types';
import { PaidSourceResource } from './paid-source.resource';

export const TrackedCallResource = ss.type({
  id: Id,
  paidSource: PaidSourceResource,

  /**
   * The destination phone number.
   *
   * If using the proxy, format this as you want it to appear on the website.
   */
  destinationPhone: ss.string(),
});

export type TrackedCallResource = ss.Infer<typeof TrackedCallResource>;
